import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_staff/person/$id/_profile/")({
  beforeLoad: ({ params }) => {
    const { id } = params;
    throw redirect({
      to: "/person/$id/personal-information",
      params: { id },
    });
  },
});
